/**
 * ChampionFactory — OCP registry: champKey → create(id, team, x, y).
 * New kits register here; callers never switch on champ id.
 */

const factories = new Map();

/**
 * @param {string} champKey
 * @param {(id: string, team: string, x: number, y: number) => object} createFn
 */
export function registerChampionFactory(champKey, createFn) {
  factories.set(String(champKey).toLowerCase(), createFn);
}

/**
 * @returns {object | null}
 */
export function createChampion(champKey, id, team, x, y) {
  const fn = factories.get(String(champKey || '').toLowerCase());
  if (!fn) return null;
  return fn(id, team, x, y);
}

export function hasChampionFactory(champKey) {
  return factories.has(String(champKey || '').toLowerCase());
}

export function listChampionKeys() {
  return [...factories.keys()];
}

/** Test-only: clear registry between cases. */
export function _resetChampionFactoriesForTests() {
  factories.clear();
}
